import React from "react"
import { Slice } from "gatsby"
import Link from "./link"
import { StaticImage } from "gatsby-plugin-image"

function HomepageFeedsSlices(): JSX.Element {
  // console.log(`HomepageFeedsSlices`)

  return (
    <>
      <div className="max-w-none w-full bg-blue border-t-0">
        <div className="w-0 h-0 mx-auto border-l-[40px] border-l-transparent border-t-[40px] border-t-white border-r-[40px] border-r-transparent"></div>
        <div className="main-container mx-auto relative z-50">
          <StaticImage
            src="../images/Bear-Tracks-Blog_IconGroup-Website_1300by650.png"
            alt="Blog Icons"
            class="hidden lg:block absolute -top-10 -right-24 w-[55%]"
          />
          <h2 className="sr-only">Bear Tracks Blog</h2>
          <StaticImage
            src="../images/Bear-Tracks-Blog_Logo-Website_300by60.png"
            alt="Blog Logo"
            className="block lg:inline-block my-auto lg:mr-0 mt-4 mb-8"
          />
          <div className="block lg:grid lg:grid-cols-12 lg:gap-12 isolate mb-8">
            <div className="lg:col-span-7">
              <Slice alias="featured-blogs" />
            </div>
            <div className="lg:col-span-5 bg-white p-8">
              <Slice alias="latest-news" />
            </div>
          </div>
          <div className="flex gap-4">
            <Link
              to="/blog"
              className="bg-white text-blue px-4 py-2 no-underline hover:bg-green hover:text-white"
            >
              Check out our blog
            </Link>
            <Link
              to="/about-georgian/contact-us/mailing-list"
              className="bg-white text-blue px-4 py-2 no-underline hover:bg-green hover:text-white"
            >
              Join our newsletter
            </Link>
          </div>
        </div>
      </div>
      <div className="max-w-none w-full">
        <div className="main-container grid lg:grid-cols-8 gap-24">
          <div className="lg:col-span-4">
            <Slice alias="upcoming-events" />
          </div>
          <div className="lg:col-span-4">
            <Slice alias="important-dates" />
          </div>
        </div>
      </div>
    </>
  )
}

export default HomepageFeedsSlices
